import React, { memo } from 'react';

/**
 * Botões de ação para células de tabela.
 * 
 * Props:
 *   onEdit   — callback editar (omitir para esconder)
 *   onDelete — callback excluir (omitir para esconder)
 */
const RowActions = memo(function RowActions({ onEdit, onDelete }) {
  return (
    <div style={{ display: 'flex', gap: '0.4rem' }}>
      {onEdit && (
        <button className="btn-secondary" style={{ padding: '0.25rem 0.6rem', fontSize: '0.75rem' }} onClick={onEdit}>
          Editar
        </button>
      )}
      {onDelete && (
        <button className="btn-danger" style={{ padding: '0.25rem 0.6rem', fontSize: '0.75rem' }} onClick={onDelete}>
          Excluir
        </button>
      )}
    </div>
  );
});

export default RowActions;
